import React from 'react';
import renderHTML from "react-render-html";

const OverviewDescription = ({ description }) => {

    return (
        <div className="row overview">
            <div className="col">
                <h2>Overview</h2>
                <p itemProp="description">
                    { renderHTML(description) }
                </p>
            </div>
        </div>
    );
}
export default OverviewDescription;



// WEBPACK FOOTER //
// ./src/pages/product/OverviewDescription.js